export default "__VITE_ASSET__B7Jve$0Y__"